import { capitalize } from 'lodash'

import { useGetUserQuery } from '@/slices/user'

import { getTerminology, prepareDictionary, smartPluralize } from './helpers'

import type { DictionaryContextValue } from './types'

export const useDictionaryData = () => {
  const { data: user, isLoading } = useGetUserQuery()
  const rmcTitle = user?.rmc?.title

  const terminology = getTerminology(rmcTitle)

  const customNames = {
    ...(user?.rmc?.corporateFilterName
      ? {
          corporate: user.rmc.corporateFilterName,
          corporates: `${user.rmc.corporateFilterName}s`,
          selectCorporate: `Select ${user.rmc.corporateFilterName}`,
          corporateFilter: user.rmc.corporateFilterName,
          corporateFilterPlaceholder: `Find ${user.rmc.corporateFilterName}`,
          altoinsightCorporateFilter: user.rmc.corporateFilterName,
          altoinsightCorporateFilterPlaceholder: `Find ${user.rmc.corporateFilterName}`,
          topCorporates: `Top ${user.rmc.corporateFilterName}s`,
        }
      : {}),
    ...(user?.rmc?.consultantFilterName
      ? {
          consultant: user?.rmc?.consultantFilterName,
          consultants: `${user?.rmc?.consultantFilterName}s`,
          topConsultants: `Top ${user?.rmc?.consultantFilterName}s`,
        }
      : {}),
    ...(user?.rmc?.employeeFilterName
      ? {
          employee: user?.rmc?.employeeFilterName,
          employees: `${smartPluralize(user?.rmc?.employeeFilterName, true)}`,
          fileNumberEmployeeIdOrReference: `File Number, ${capitalize(
            user?.rmc?.employeeFilterName
          )} ID or Reference`,
        }
      : {}),
  }

  const dictionary = prepareDictionary(terminology, customNames)
  const isPwCUser = !!user?.rmc?.pwc

  const dictionaryData: DictionaryContextValue = {
    terminology,
    dictionary,
    isPwCUser,
    isLoading,
  }

  return dictionaryData
}
